module.exports = __webpack_public_path__ + "static/media/feta_meli2.ea1cf122.jpg";